export default function Projects(){
    return (
        <div>
            <div class="container">
          <h2 class="display-5">Projects</h2>
          <br />
          <div class="row">
            <div class="col-md-3">
              <div class="card project">
                <div class="card-body">
                  <h5 class="card-title">Report it!</h5>
                  <h6 class="card-subtitle mb-2 text-muted">Android, Node.js &amp; MongoDB</h6>
                  <p class="card-text">Fake news reporting &amp; identification system</p>
                  <a href="https://github.com/october7sveryown/report-fake-news" class="card-link" target="_blank" rel="noopener noreferrer"><span>browse</span></a>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card project">
                <div class="card-body">
                  <h5 class="card-title">Resourcify</h5>
                  <h6 class="card-subtitle mb-2 text-muted">Android, PHP &amp; MySQL</h6>
                  <p class="card-text">Daily Inward/Outward Transaction Report System</p>
                  <a href="https://github.com/october7sveryown/Resourcify" class="card-link" target="_blank" rel="noopener noreferrer"><span>browse</span></a>
                </div>
              </div>
            </div>
            <div class="col-md-3 ">
              <div class="card project">
                <div class="card-body">
                  <h5 class="card-title">GIC</h5>
                  <h6 class="card-subtitle mb-2 text-muted">Android, PHP &amp; MySQL</h6>
                  <p class="card-text">Official app of GTU innovation council</p>
                  <a href="https://github.com/october7sveryown/Gicmain" class="card-link" target="_blank" rel="noopener noreferrer"><span>browse</span></a>
                </div>
              </div>
            </div>
            <div class="col-md-3 ">
              <div class="card project">
                <div class="card-body">
                  <h5 class="card-title">Invoice generator</h5>
                  <h6 class="card-subtitle mb-2 text-muted">JavaScript</h6>
                  <p class="card-text">Form data into PDF invoice generator</p>
                  <a href="https://github.com/october7sveryown/invoice-gen" class="card-link" target="_blank" rel="noopener noreferrer"><span>browse</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
    )
}